import { render, staticRenderFns } from "./CreditCardPaymentComponentSecurepay.vue?vue&type=template&id=152a73c0"
import script from "./CreditCardPaymentComponentSecurepay.vue?vue&type=script&lang=js"
export * from "./CreditCardPaymentComponentSecurepay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports